import emailjs from '@emailjs/browser'

const EMAILJS_SERVICE_ID = 'service_s5bv5j1'
const EMAILJS_QUOTE_TEMPLATE_ID = 'template_pkosu4k'
const EMAILJS_CONTACT_TEMPLATE_ID = 'YOUR_EMAILJS_CONTACT_TEMPLATE_ID'
const EMAILJS_PUBLIC_KEY = '3jh-dl98XRTnMveuO'

export interface QuoteFormData {
  name: string
  email: string
  phone: string
  company: string
  services: string
  specialties: string
  description: string
  timeline: string
  budget: string
}

export interface ContactFormData {
  name: string
  email: string
  message: string
}

export const sendQuoteRequest = async (formData: QuoteFormData) => {
  try {
    // Build services_summary: combines services, specialties, and per-service descriptions
    const servicesSummary = formData.services

    const templateParams = {
      client_name: formData.name,
      client_email: formData.email,
      client_phone: formData.phone,
      client_company: formData.company,
      services_summary: servicesSummary,
      project_description: formData.description,
      project_timeline: formData.timeline,
      project_budget: formData.budget,
    }

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_QUOTE_TEMPLATE_ID,
      templateParams,
      EMAILJS_PUBLIC_KEY,
    )
    return response
  } catch (error) {
    console.error('Error sending quote request:', error)
    throw error
  }
}

export const sendContactForm = async (formData: ContactFormData) => {
  try {
    const templateParams = {
      client_name: formData.name,
      client_email: formData.email,
      message: formData.message,
    }

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_CONTACT_TEMPLATE_ID,
      templateParams,
      EMAILJS_PUBLIC_KEY,
    )
    return response
  } catch (error) {
    console.error('Error sending contact form:', error)
    throw error
  }
}
